export default "__VITE_ASSET__52366789__"